import Vue from 'vue';
import VueRouter from 'vue-router';
import translate from './modules/translate';
import appManage from './modules/appManage';
import baseRouter from './baseRouter';
import ticketInfo from './modules/detail';

import testData from './modules/testData';

import appName from './modules/appName';

import assetManage from './modules/assetManage';

import poManage from './modules/poManage';

import facilityManage from './modules/facilityManage';

import boardManage from './modules/boardManage';

import platformManage from './modules/platformManage';

import workOrderManage from './modules/workOrderManage';

Vue.use(VueRouter);
const routes = [
  ...translate,
  ...appManage,
  ...baseRouter,
  ...ticketInfo,
  ...testData,
  ...appName,
  ...assetManage,
  ...poManage,
  ...facilityManage,
  ...boardManage,
  ...platformManage,
  ...workOrderManage,
];

const appManage1 = [...appManage];

const router = new VueRouter({
  mode: 'history',
  routes,
  translate,
  appManage,
  ticketInfo,
  testData,
  baseRouter,
  assetManage,
  poManage,
  facilityManage,
  boardManage,
  platformManage,
  workOrderManage,
});

console.log('全部的路由路径小的路径', router);

/**
 * 顶栏导航聚合：每块顶栏对应多段 Layout 路由，下拉展示各段 meta.title 及其子菜单
 */
const TOP_NAV_CONFIG = {
  appManage: {
    title: '业务管理',
    routeNames: ['poManage', 'appManage', 'billManage', 'orderAudit', 'staffManage', 'workOrderManage'],
    defaultPath: '/poManage/formal/list',
    activeSegments: ['poManage', 'appManage', 'billManage', 'auditManage', 'staffManage', 'workOrderManage'],
  },
  boardManage: {
    title: '数据看板',
    routeNames: ['boardManage'],
    defaultPath: '/boardManage/formal/dcopsOperation/serverMove',
    activeSegments: ['boardManage'],
  },
  platformManage: {
    title: '平台建设',
    routeNames: ['basicInfo', 'ConfigManage', 'serviceCenter'],
    defaultPath: '/platformManage/formal/slaInfo',
    activeSegments: ['platformManage', 'configManage', 'serverCenter'],
  },
  facilityManage: {
    title: '设施运维',
    routeNames: ['facilityManageHome', 'facilityManage', 'operationManage'],
    defaultPath: '/facilityManage/home/index',
    activeSegments: ['facilityManage', 'operationManage'],
  },
};

function isExternalPath(path) {
  return typeof path === 'string' && /^(https?:|mailto:|tel:)/.test(path);
}

function processChildren(children, parentPath) {
  return (children || []).map((child) => {
    // 外链保持原 URL，避免被拼成 /parent/http:/xxx
    const fullPath = isExternalPath(child.path)
      ? child.path
      : `${parentPath}/${child.path}`.replace(/\/+/g, '/');
    return {
      ...child,
      path: fullPath,
      children: processChildren(child.children, fullPath),
    };
  });
}

function buildAggregatedNavChildren(routeNames, allRoutes) {
  return routeNames
    .map((routeName) => {
      const route = allRoutes.find((r) => r.name === routeName);
      if (!route) return null;
      const basePath = route.path.startsWith('/') ? route.path : `/${route.path}`;
      return {
        ...route,
        path: basePath,
        children: processChildren(route.children, basePath),
      };
    })
    .filter(Boolean);
}

/** 路径首段 -> 顶栏 name，用于高亮 */
export const TOP_NAV_ACTIVE_SEGMENTS = Object.fromEntries(
  Object.entries(TOP_NAV_CONFIG).flatMap(([navName, cfg]) =>
    (cfg.activeSegments || [navName]).map((seg) => [seg, navName])
  )
);

/** 点击顶栏默认跳转 */
export const TOP_NAV_DEFAULT_PATHS = Object.fromEntries(
  Object.entries(TOP_NAV_CONFIG).map(([name, cfg]) => [name, cfg.defaultPath])
);

export const ROUTES = Object.entries(TOP_NAV_CONFIG).map(([name, cfg]) => {
  const allRoutes = router.options?.routes || [];
  return {
    name,
    title: cfg.title,
    path: `/${name}`,
    children: buildAggregatedNavChildren(cfg.routeNames, allRoutes),
  };
});

console.log('全部的路由路径', ROUTES);

export default router;
